import React, { useState, useEffect, useContext } from "react";
import DataContext from "../../../utils/Context/DataContext";
import { api } from "../../../utils/Api";
import { Link, useParams } from "react-router-dom";
import ReactDatatable from "@ashvin27/react-datatable";
import ModalCreateOutlet from "./ModalCreateOutlet";
import ModalEditOutlet from "./ModalEditOutlet";
import SwipeableDrawer from "@material-ui/core/SwipeableDrawer";

import DeleteAlert from "../../../components/Alert/DeleteAlert";

const table_config = {
  key_column: "id",
  page_size: 10,
  length_menu: [10, 20, 50],
  show_filter: true,
  show_pagination: true,
  button: {
    excel: false,
    print: false,
  },
  language: {
    loading_text: "Please be patient while data loads...",
  },
};

const table_header = [
  {
    name: "Name",
    width: "30",
  },
  {
    name: "Address",
    width: "30",
  },
  {
    name: "Mobile Number",
    width: "30",
  },
  {
    name: "",
    width: "10",
  },
];

export default function AdminOutlet(props) {
  const context = useContext(DataContext);
  const [id_value, SerIdValue] = useState(useParams());
  const [outlet_data, SetOutletData] = useState([]);
  const [create_outlet_modal, SetCreateOutletModal] = useState({
    is_open: false,
    data: {},
  });
  const [edit_outlet_modal, SetEditOutletModal] = useState({
    is_open: false,
    data: {},
    index: "",
  });
  const [state, setState] = React.useState({
    bottom: false,
  });
  const [selected_data, SetSelectedData] = useState({
    value: "",
    i: "",
  });
  const [delete_modal, SetDeleteModal] = useState({
    is_open: false,
    title: "",
    record: {},
    index: "",
  });

  function sample_fun(anchor, open, event) {
    console.log("sample_fun anchor :", anchor);
    console.log("sample_fun open :", open);
    console.log("sample_fun event :", event);
    if (
      event &&
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      console.log("return");
      return;
    }
    console.log("toggle else");

    setState({ ...state, [anchor]: open });
    // toggleDrawer("bottom", true);
  }

  const list = (anchor) => (
    <div
      className="mt-3"
    // className={ anchor === 'top' || anchor === 'bottom'}
    // role="presentation"
    // onClick={toggleDrawer(anchor, false)}
    // onKeyDown={toggleDrawer(anchor, false)}
    >
      <div>
        <div className="d-flex justify-content-center">
          <div className="w-25 px-4">
            <hr className="h-3" />
          </div>
        </div>
        <ul>
          {/* view */}
          <li className="p-2 pb-3 cursor align-center">
            <Link
              className="cursor text-dark"
              to={
                "/brand/" +
                id_value.brand_id +
                "/view_outlet/" +
                selected_data.value.id +
                "/details"
              }
            >
              <img
                src={require("../../../assets/icon/svg/eye.svg")}
                className="action_menu_img cursor"
              />
              &nbsp; View
            </Link>
          </li>
          {/* Edit */}
          {/* <li
            className="p-2 pb-3 cursor align-center"
            onClick={() => {
              SetEditOutletModal({
                is_open: true,
                data: selected_data.value,
                index: selected_data.i,
              });
              console.log("Edit");
              sample_fun(anchor, false, event);
            }}
          >
            <img
              src={require("../../../assets/icon/svg/edit-3.svg")}
              className="me-2 action_menu_img cursor"
            />
            Edit
          </li> */}
          {/* Delete */}
          {/* <li
            className="p-2 pb-3 cursor align-center"
            onClick={(event) => {
              delete_outlet(selected_data.i, selected_data.value);
              sample_fun(anchor, false, event);
            }}
          >
            <img
              src={require("../../../assets/icon/svg/trash-2.svg")}
              className="me-2 action_menu_img cursor"
            />
            Delete
          </li> */}
        </ul>
      </div>
    </div>
  );

  useEffect(() => {
    console.log("AdminOutlet On mount :", props);
    console.log("AdminOutlet context :", context);
    get_outlets();
  }, []);

  async function get_outlets() {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
      },
    };
    let response = await api("/brand/outlets", pass_data);
    console.log("/brand/outlets response :", response);
    if (response.status_code == 200) {
      if (response.response.hasOwnProperty("outlets")) {
        SetOutletData(response.response.outlets);
      } else {
        SetOutletData([]);
      }
    }
  }

  async function delete_outlet(data: any, index: any) {
    let pass_data = {
      get: {
        brand: id_value.brand_id,
      },
      post: {
        outlet_id: data.id,
      },
    };
    let response = await api("/brand/delete_outlet", pass_data);
    console.log("/brand/delete_outlet response :", response);
    if (response.status_code == 200) {
      let old_outlet_data = outlet_data;
      old_outlet_data.splice(index, 1);
      SetOutletData([...old_outlet_data]);
      // get_outlets();
    }
  }

  return (
    <div>
      <div className="bg-fff py-3 px-4">
        <div className="row align-items-center pb-2">
          <div className="col-md-5 col-6">
            <h5 className="  mb-0 text-dark fw-bolder">Outlets</h5>
          </div>
          <div className="col-md-7 col-6 justify-content-end d-flex align-items-center cursor">
            <div
              className="btn-light-outline d-flex align-items-center text-dark cursor py-1 px-2 "
              onClick={() => {
                console.log("Outlet Add");
                SetCreateOutletModal((oldValues) => ({
                  ...oldValues,
                  is_open: true,
                }));
              }}
            >
              <img
                src={require("../../../assets/icon/svg/plus1.svg")}
                className=" pe-2"
              />{" "}
              Add
            </div>
          </div>
        </div>
      </div>
      <div className="container-fuild p-3">
        <div className="card p-3">
          <div className="row p-3">
            <div className="col-md-8 pb-2">
              <div className="d-flex align-items-center">
                <p className="mb-0 pe-2">Show</p>
                <select
                  className="form-select flex-basis-20"
                  aria-label="Default select example"
                  defaultValue={10}
                >
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                </select>
                <p className="mb-0 ps-2">records per page</p>
              </div>
            </div>
            <div className="col-md-4 pb-2 text-end">
              <input
                type="text"
                className="form-control"
                id="staticEmail"
                placeholder="Search in records..."
              />
            </div>
          </div>

          {outlet_data.length > 0 ? (
            <div>
              <div className="d-lg-block d-md-none">
                <table className="table table-hover">
                  <thead>
                    <tr>
                      {table_header.map((head, t_index) => (
                        <th key={t_index}>{head.name}</th>
                      ))}
                    </tr>
                  </thead>
                  <tbody>
                    {outlet_data.map((data, o_index) => (
                      <tr key={o_index}>
                        <td className="mb-1">{data.name}</td>
                        <td>{data.address}</td>
                        <td>{data.mobile}</td>
                        <td className="dropdown cursor">
                          <div
                            id="dropdownMenuButton1"
                            data-bs-toggle="dropdown"
                            aria-expanded="false"
                          >
                            <img
                              src={require("../../../assets/icon/svg/more-horizontal.svg")}
                              className="action_img cursor"
                            />
                          </div>
                          <ul
                            className="dropdown-menu"
                            aria-labelledby="dropdownMenuButton1"
                          >
                            {/* View */}
                            <li>
                              <Link
                                className="cursor dropdown-item"
                                to={
                                  "/brand/" +
                                  id_value.brand_id +
                                  "/view_outlet/" +
                                  data.id +
                                  "/details"
                                }
                              >
                                <img
                                  src={require("../../../assets/icon/svg/eye.svg")}
                                  className="action_menu_img cursor"
                                />
                                &nbsp; View
                              </Link>
                            </li>
                            {/* Edit */}
                            {/* <li>
                            <div
                              className="cursor dropdown-item"
                              onClick={() => {
                                SetEditOutletModal({
                                  is_open: true,
                                  data: data,
                                  index: o_index,
                                });
                                console.log("Edit");
                              }}
                            >
                              <img
                                src={require("../../../assets/icon/svg/edit-3.svg")}
                                className="action_menu_img cursor"
                              />
                              &nbsp; Edit
                            </div>
                          </li> */}
                            {/* Delete */}
                            {/* <li>
                            <div
                              className="cursor dropdown-item"
                              onClick={() => {
                                // delete_outlet(data, o_index);
                                SetDeleteModal((prevValue) => {
                                  prevValue.is_open = true;
                                  prevValue.title = "Outlet";
                                  prevValue.record = data;
                                  prevValue.index = o_index;
                                  return { ...prevValue };
                                });
                              }}
                            >
                              <img
                                src={require("../../../assets/icon/svg/trash-2.svg")}
                                className="action_menu_img cursor"
                              />
                              &nbsp; Delete
                            </div>
                          </li> */}
                          </ul>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>

              <div className="d-lg-none">
                {outlet_data.map((data, o_index) => (
                  <div
                    key={o_index}
                    className="row mb-2 border-bottom"
                    onClick={(event) => {
                      sample_fun("bottom", true, event);
                      SetSelectedData({
                        value: data,
                        i: o_index,
                      });
                    }}
                  >
                    <h6 className="mb-1">{data.name}</h6>

                    <div className="col-6">
                      <p className="v-small">{data.address}</p>
                    </div>
                    <div className="col-6 ps-0 text-end">
                      <p>{data.mobile}</p>
                    </div>
                  </div>
                ))}
              </div>

            </div>
          ) : (
            <div className="text-center">
              <img
                src={require("../../../assets/img/svg/no_data_2.svg")}
                className="w-30 pb-2"
              />
              <p className="v-small mb-0">No Data, Please Add Outlet</p>
            </div>
          )}
        </div>

        <ModalCreateOutlet
          open={create_outlet_modal.is_open}
          close={(data) => {
            console.log("Create Outlet Modal On Close :", data);
            SetCreateOutletModal((oldValues) => ({
              ...oldValues,
              is_open: false,
            }));
            if (data.action == "save") {
              SetOutletData((prevValue) => {
                console.log("prevValue :", prevValue);
                if (prevValue == undefined) {
                  prevValue = [];
                  prevValue.push(data.value);
                } else {
                  prevValue.push(data.value);
                }
                return [...prevValue];
              });
            }
          }}
        />

        <ModalEditOutlet
          open={edit_outlet_modal.is_open}
          data={edit_outlet_modal.data}
          index={edit_outlet_modal.index}
          close={(data) => {
            console.log("Edit Outlet Modal On Close :", data);
            SetEditOutletModal({
              is_open: false,
              data: {},
              index: "",
            });
            if (data.action == "edit") {
              SetOutletData((prevValue) => {
                prevValue[data.index] = data.value;
                return [...prevValue];
              });
            }
          }}
        />
      </div>

      <DeleteAlert
        open={delete_modal.is_open}
        title={delete_modal.title}
        record={delete_modal.record}
        index={delete_modal.index}
        close={(data) => {
          SetDeleteModal((prevValue) => {
            prevValue.is_open = false;
            return { ...prevValue };
          });

          if (data.action === "delete") {
            console.log("delete Outlet : ", data);
            delete_outlet(data.value, data.index);
            // delete_service(data.value, data.index);
          }
        }}
      />

      {["left", "right", "top", "bottom"].map((anchor) => (
        <React.Fragment key={anchor}>
          <SwipeableDrawer
            anchor={anchor}
            open={state[anchor]}
            // onClose={toggleDrawer(anchor, false)}
            // onOpen={toggleDrawer(anchor, true)}
            onClose={(event) => {
              sample_fun(anchor, false, event);
            }}
            onOpen={(event) => {
              sample_fun(anchor, true, event);
            }}
          >
            {list(anchor)}
          </SwipeableDrawer>
        </React.Fragment>
      ))}
    </div>
  );
}
